<template>
  <div class="notifications">
    <div :class="['loading-area', loading ? 'loading' : '']">
      <div :class="['loading-area__content', loading ? 'loading' : '']">
        <div class="notifications__content">
          <div :id="row.post" class="notifications__notification" v-for="(row, key) in announcements"
               :key="key" @click="post(row.post)">
            <h6>{{ row.title }}</h6>

            <small>
              <p>{{ row.message }}</p>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [client],
  data: function () {
    return {
      loading: false,
      announcements: []
    }
  },
  methods: {
    go: function (id) {
      this.$router.push('/vendors/' + id)
    },
    getVendors: function () {
      this.loading = true

      this.request('get', '/shopify/announcements/', {
        sort: '-created_date',
        page_size: 5
      }).then(response => {
        this.announcements = response.results

        this.loading = false
      })
    }
  },
  created () {
    this.getVendors()
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';

  .notifications {
    &__content {
      max-height: 300px;
      overflow: scroll;
    }

    &__notification {
      border-bottom: 1px solid $dark-gray;
      margin-bottom: 15px;
      padding-bottom: 15px;

      &:last-child {
        border-bottom: 0;
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/announcements.vue